
let React = require("react");

class Cover extends React.Component {

    shouldComponentUpdate(nextProps, nextState){
        return false;
    }

    render() {                         
        return  <section className="cover">
                    <div className="container">
                        <h1>Explore</h1>
                        <p>Discover publicly shared libraries, packages, and 3D models.</p>
                    </div>
                </section>;
    }
}

module.exports = Cover;
